import { render, staticRenderFns } from "./EntityLockModal.vue?vue&type=template&id=eda2c22e&"
import script from "./EntityLockModal.vue?vue&type=script&lang=ts&"
export * from "./EntityLockModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports